// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__21NpR","colCheckbox":"styles_colCheckbox__2F86H"};